module.exports = __webpack_public_path__ + "static/m_4-92f675e721839447e96547b4090b07af.png";